import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "h-full w-full bg-primarySecond" }
const _hoisted_2 = { class: "container mx-auto h-full w-full" }
const _hoisted_3 = { class: "grid grid-cols-1 max-h-[calc(100vh-18rem)] xl:max-h-[calc(100vh-8rem)] overflow-y-scroll overflow-x-hidden scrollbar-none" }
const _hoisted_4 = { class: "col-span-full pb-4" }
const _hoisted_5 = { class: "text-xl" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-2 w-1/3 border-t-2 border-accent" }, null, -1)
const _hoisted_7 = { class: "mt-2 text-xs uppercase tracking-wider" }
const _hoisted_8 = { class: "w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.postData.title), 1),
          _hoisted_6,
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.Utils.formatDate(_ctx.postData.createdAt)), 1),
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.postData.blocks, (block) => {
              return (_openBlock(), _createBlock(_resolveDynamicComponent(block.component), _mergeProps({ class: "text-start mt-3" }, block.data, {
                key: block.position
              }), null, 16))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}